import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { X, Plus, Trash2, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ChatSidebarProps {
  onCloseSidebar: () => void;
}

const ChatSidebar: React.FC<ChatSidebarProps> = ({ onCloseSidebar }) => {
  const [conversations, setConversations] = useState([
    { id: '1', title: 'Negociação com fornecedores', date: '2023-05-14' },
    { id: '2', title: 'Automação de compras', date: '2023-05-13' },
  ]);

  const startNewChat = () => {
    window.location.href = '/chat';
  };

  const deleteConversation = (id: string) => {
    setConversations(conversations.filter((conv) => conv.id !== id));
  };

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-border flex items-center justify-between">
        <h2 className="font-display font-bold text-brand-azul">dgenny chat</h2>
        <Button variant="ghost" size="icon" className="md:hidden" onClick={onCloseSidebar}>
          <X className="h-4 w-4" />
        </Button>
      </div>

      <div className="p-3">
        <Button
          className="w-full bg-brand-roxo hover:bg-brand-roxo/90 text-white font-semibold rounded-full flex items-center gap-2"
          onClick={startNewChat}
        >
          <Plus className="h-4 w-4" /> Nova conversa
        </Button>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="px-2 py-3">
          <h3 className="text-xs font-semibold text-brand-azul/50 uppercase tracking-wider px-2 mb-2">
            Conversas anteriores
          </h3>

          {conversations.length > 0 ? (
            <ul className="space-y-1">
              {conversations.map((conv) => (
                <li key={conv.id}>
                  <Link
                    to={`/chat/${conv.id}`}
                    className="flex items-start group px-2 py-2 rounded-lg hover:bg-muted/60"
                  >
                    <div className="flex-shrink-0 mt-0.5">
                      <MessageSquare className="h-4 w-4 text-brand-azul/50" />
                    </div>
                    <div className="ml-3 flex-1 overflow-hidden">
                      <p className="text-sm font-medium text-brand-azul truncate">
                        {conv.title}
                      </p>
                      <p className="text-xs text-brand-azul/50">
                        {new Date(conv.date).toLocaleDateString('pt-BR')}
                      </p>
                    </div>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="opacity-0 group-hover:opacity-100"
                      onClick={(e) => {
                        e.preventDefault();
                        deleteConversation(conv.id);
                      }}
                    >
                      <Trash2 className="h-4 w-4 text-brand-azul/50 hover:text-red-500" />
                    </Button>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-center text-brand-azul/50 text-sm py-4">
              Nenhuma conversa anterior
            </p>
          )}
        </div>
      </div>

      <div className="p-4 border-t border-border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-brand-azul/50">Powered by</p>
            <p className="text-sm font-display font-bold text-brand-azul">dgenny AI</p>
          </div>
          <Link to="/" className="text-xs text-brand-roxo font-semibold hover:underline">
            Voltar ao site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChatSidebar;
